var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_144",
    "data-name": "Grupo 144",
    transform: "translate(1 253.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_237",
    "data-name": "Trazado 237",
    d: "M9-267.687a.908.908,0,0,1,.285.046.909.909,0,0,1,.3.167l9.078,7.338a.909.909,0,0,1,.269,1.054l-.56,1.359a.909.909,0,0,1-.616.534.909.909,0,0,1-.8-.174l-.168-.136v8.9a.909.909,0,0,1-.909.909h-5.4a.909.909,0,0,1-.909-.909v-6.659H8.294v6.659a.909.909,0,0,1-.909.909h-5.4a.909.909,0,0,1-.909-.909v-8.8l-.039.031a.909.909,0,0,1-.8.174.909.909,0,0,1-.616-.534l-.56-1.359a.909.909,0,0,1,.269-1.053l9.082-7.342a.908.908,0,0,1,.253-.148A.909.909,0,0,1,9-267.687Zm6.605,7.418L9-265.609l-6.735,5.444a.9.9,0,0,1,.116.046.909.909,0,0,1,.517.82v9.793H6.476v-6.659a.909.909,0,0,1,.909-.909h3.1a.909.909,0,0,1,.909.909v6.659h3.578v-9.9a.909.909,0,0,1,.517-.82A.919.919,0,0,1,15.605-260.269Z",
    transform: "translate(0 14)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.26bdba08.svg";
export { ForwardRef as ReactComponent };